<template>
  <div class="main-wrapper">
    <nav
      class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top"
      id="sideNav"
    >
      <a class="navbar-brand js-scroll-trigger" href="#about">
        <span class="d-block d-lg-none">Portfolio</span>
        <span class="d-none d-lg-block">
          <img
            class="img-fluid img-profile rounded-circle mx-auto mb-2"
            src="./assets/profile.jpg"
            alt=""
          />
        </span>
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#about">About</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#experience"
              >Experience</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#education"
              >Education</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#skills">Skills</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#projects">Projects</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#interests"
              >Interests</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#awards"
              >Certifications</a
            >
          </li>
        </ul>
      </div>
    </nav>

    <div class="container-fluid p-0">
      <section class="resume-section p-3 p-lg-5 d-flex d-column" id="about">
        <div class="my-auto">
          <h1 class="mb-0">
            {{ name }}
            <span class="text-primary">{{ surname }}</span>
          </h1>
          <div class="subheading mb-5">
            {{ address }}
            <a href="mailto:baptiste@beduneau.com">{{ email }}</a> -
            <a
              href="./files/publickey.baptiste@beduneau.com.asc"
              download=""
              class="ml-2"
              >PGP KEY</a
            >
          </div>
          <p class="mb-5 text-block">{{ aboutMe }}</p>
          <ul class="list-inline list-social-icons mb-0">
            <li class="list-inline-item">
              <a
                href="https://www.linkedin.com/in/baptiste-beduneau/"
              >
                <span class="fa-stack fa-lg">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa fa-linkedin fa-stack-1x fa-inverse"></i>
                </span>
              </a>
            </li>
            <li class="list-inline-item">
              <a href="https://github.com/BaptisteBdn">
                <span class="fa-stack fa-lg">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa fa-github fa-stack-1x fa-inverse"></i>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </section>

      <section
        class="resume-section p-3 p-lg-5 d-flex flex-column"
        id="experience"
      >
        <div class="my-auto">
          <h2 class="mb-5">Experience</h2>

          <div
            class="resume-item d-flex flex-column flex-md-row mb-5"
            v-for="job in experience"
            :key="job.position"
          >
            <div class="resume-content mr-auto">
              <h3 class="mb-0">{{ job.position }}</h3>
              <div class="subheading mb-3">{{ job.company }}</div>
              <div
                v-if="job.descriptionHtml"
                class="job-description"
                v-html="job.descriptionHtml"
              ></div>
              <div v-else class="text-block">{{ job.description }}</div>
            </div>
            <div class="resume-date text-md-right">
              <span class="text-primary"
                >{{ job.startDate }} - {{ job.endDate }}</span
              >
            </div>
          </div>
        </div>
      </section>

      <section
        class="resume-section p-3 p-lg-5 d-flex flex-column"
        id="education"
      >
        <div class="my-auto">
          <h2 class="mb-5">Education</h2>
          <div
            class="resume-item d-flex flex-column flex-md-row mb-5"
            v-for="job in education"
            :key="job.description"
          >
            <div class="resume-content mr-auto">
              <h3 class="mb-0">{{ job.position }}</h3>
              <div class="subheading mb-3">{{ job.company }}</div>
              <div class="text-block">{{ job.description }}</div>
            </div>
            <div class="resume-date text-md-right">
              <span class="text-primary"
                >{{ job.startDate }} - {{ job.endDate }}</span
              >
            </div>
          </div>
        </div>
      </section>

      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="skills">
        <div class="my-auto">
          <h2 class="mb-5">Skills</h2>

          <div class="subheading mb-3">Technical Skills</div>
          <ul style="list-style-type: disc;">
            <li><strong>Security Operations Center:</strong> SIEM, EDR/XDR, EPP, IDS/IPS</li>
            <li><strong>Automation:</strong> SOAR, Python, Ansible, Bash, REST APIs, Webhooks</li>
            <li><strong>AI &amp; Cybersecurity:</strong> Design of AI workflows and agents for SOC automation</li>
            <li><strong>Vulnerability Management:</strong> Vulnerability scanners, ASM</li>
            <li><strong>Offensive Security:</strong> Burp Suite, Metasploit, Nmap, Kali Linux</li>
            <li><strong>Infrastructure:</strong> Linux, Windows, AD, Docker, Firewalls, VPN, Proxy, DNS</li>
            <li><strong>ISO 27001</strong></li>
            <li><strong>DevSecOps:</strong> Security controls in CI/CD pipelines</li>
          </ul>

          <div class="subheading mb-3">Leadership</div>
          <ul style="list-style-type: disc;">
            <li>KPI definition</li>
            <li>Project management</li>
            <li>Audit program management</li>
            <li>Risk management</li>
          </ul>
        </div>
      </section>

      <section
        class="resume-section p-3 p-lg-5 d-flex flex-column"
        id="projects"
      >
        <div class="my-auto">
          <h2 class="mb-5">Projects</h2>
          <div
            class="resume-item d-flex flex-column flex-md-row mb-5"
            v-for="job in projects"
            :key="job.description"
          >
            <div class="resume-content mr-auto">
              <h3 class="mb-0"><a :href="job.url">{{ job.position }}</a></h3>
              <div class="subheading mb-3">{{ job.company }}</div>
              <div class="text-block">{{ job.description }}</div>
            </div>
            <div class="resume-date text-md-right">
              <span class="text-primary"
                >{{ job.startDate }} - {{ job.endDate }}</span
              >
            </div>
          </div>
        </div>
      </section>

      <section
        class="resume-section p-3 p-lg-5 d-flex flex-column"
        id="interests"
      >
        <div class="my-auto">
          <h2 class="mb-5">Interests</h2>
          <ul style="list-style-type: disc;">
            <li>Video games (RPGs, competitive games)</li>
            <li>Climbing (Bouldering)</li>
            <li>Biking (Moutain and Gravel)</li>
            <li>Cooking</li>
            <li>Linux & i3</li>
            <li>CTFs</li>
            <li>Japanese</li>
          </ul>
        </div>
      </section>

      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="awards">
        <div class="my-auto">
          <h2 class="mb-5">Certifications</h2>
          <div
            class="resume-item d-flex flex-column flex-md-row mb-5"
            v-for="job in certification"
            :key="job.company"
          >
            <div class="resume-content mr-auto">
              <h3 class="mb-0">{{ job.position }}</h3>
              <div class="subheading mb-3">{{ job.company }}</div>
            </div>
            <div class="resume-date text-md-right">
              <span class="text-primary">{{ job.startDate }}</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "BAPTISTE",
      surname: "BEDUNEAU",
      email: "baptiste@beduneau.com",
      aboutMe:
        "Cybersecurity & DevOps enthusiast.",
      experience: [
        {
          position: "LEAD CYBERSECURITY ENGINEER",
          company: "Nameshield group",
          description: "",
          descriptionHtml: `
            <p><strong>Built and led the internal technical security team</strong> (3 people), responsible for structuring detection, incident response, vulnerability management and offensive security capabilities.</p>
            <p class="job-section"><strong>SOC &amp; Incident Response</strong></p>
            <ul>
              <li>Built and maintained in operational condition the <strong>internal SOC</strong>, covering 150+ users and 2,000+ endpoints, mostly on-premise.</li>
              <li>Designed, deployed and maintained an ecosystem of <strong>10+ security tools</strong>, including <strong>SIEM, SOAR, EDR and EPP</strong>.</li>
              <li>Automated incident response processes by building <strong>SOAR playbooks</strong> and integrating the various security tools.</li>
              <li>Defined and improved capabilities for detecting, qualifying, investigating and responding to security incidents.</li>
            </ul>
            <p class="job-section"><strong>VOC - Vulnerability Management</strong></p>
            <ul>
              <li>Set up and led a <strong>Vulnerability Operations Center (VOC)</strong> dedicated to monitoring the company’s exposure.</li>
              <li>Centralized, qualified and <strong>prioritized vulnerabilities</strong> based on their severity, exploitability and impact on the information system.</li>
              <li>Tracking, remediation and <strong>reporting of vulnerabilities</strong>.</li>
            </ul>
            <p class="job-section"><strong>Offensive Security &amp; Audits</strong></p>
            <ul>
              <li>Defined and managed an <strong>annual program of 15+ security audits</strong>, based on business stakes and company needs.</li>
              <li>Personally conducted <strong>2 to 3 audits per year</strong>, including <strong>penetration tests, architecture audits and configuration audits</strong>.</li>
              <li>Identified attack scenarios, analyzed exploitable vulnerabilities and supported technical teams through remediation.</li>
            </ul>
            <p class="job-section"><strong>Governance, Management &amp; Compliance</strong></p>
            <ul>
              <li>Defined and monitored the security team’s <strong>performance and activity KPIs</strong>.</li>
              <li>Defined security best practices in line with applicable frameworks and standards, and controlled their enforcement.</li>
              <li>Contributed to maintaining the ISO 27001 certification: preparing and providing evidence, monitoring security controls, taking part in certification and surveillance audits, and following up on the remediation of non-conformities.</li>
            </ul>`,
          startDate: "jun. 2023",
          endDate: "today",
        },
        {
          position: "SECURITY ENGINEER - CERT",
          company: "Nameshield group",
          description: "",
          descriptionHtml: `
            <p>Member and co-creator of the <strong>Nameshield CERT</strong>, in an ISO 27001 certified company.</p>
            <ul>
              <li><strong>Cybersecurity incident handling</strong> and employee security awareness.</li>
              <li>Supported development teams by providing a global view of <strong>threats, vulnerabilities and countermeasures</strong>.</li>
              <li>Standardized the team’s processes to join the <strong>InterCERT-FR, TF-CSIRT and FIRST</strong> communities.</li>
              <li>Performed <strong>cybersecurity audits</strong> of web applications.</li>
              <li>Developed security task automation to optimize and improve efficiency.</li>
            </ul>`,
          startDate: "aug. 2021",
          endDate: "jun. 2023",
        },
        {
          position: "SITE RELIABILITY ENGINEER",
          company: "Nameshield group",
          description: "",
          descriptionHtml: `
            <ul>
              <li>Developed <strong>cybersecurity automation and analysis tools</strong>.</li>
              <li>Set up and maintained applications in a <strong>containerized environment</strong>.</li>
              <li>Software development (<strong>Python, Java, PHP, JavaScript ES6+</strong>) and system administration of a mostly on-premise infrastructure (<strong>Bash, LXC, ZFS, Ansible</strong>).</li>
              <li>Helped design an <strong>AWS</strong> analysis application (EC2, Lambda, Kinesis) using IaC (<strong>Terraform</strong>).</li>
              <li>Documented, analyzed and drafted projects within a team of 10 sysadmins to improve visibility and prioritization in an <strong>Agile</strong> environment.</li>
            </ul>`,
          startDate: "sept. 2019",
          endDate: "aug. 2021",
        },
        {
          position: "SOFTWARE ENGINEER",
          company: "Nameshield group",
          description: "",
          descriptionHtml: `
            <ul>
              <li>Designed and developed a <strong>cybersecurity tool</strong> to detect and prevent <strong>domain name anomalies</strong>.</li>
              <li>Built with <strong>Java and Python</strong>, relying on DNS technologies and research.</li>
            </ul>`,
          startDate: "sept. 2018",
          endDate: "sept. 2019",
        },
        {
          position: "SOFTWARE ENGINEER INTERN",
          company: "Innoseis",
          description: "",
          descriptionHtml: `
            <p>Four-month internship in the <strong>NIKHEF</strong> group as a software engineer.</p>
            <ul>
              <li>Operated and tested a GPS module.</li>
              <li>Implemented a Windows application to manage and visualize a software database.</li>
            </ul>`,
          startDate: "aug. 2017",
          endDate: "nov. 2017",
        },
      ],
      education: [
        {
          position: "ESEO Angers",
          company: "Engineering degree in Computer Science",
          description: "Cloud Computing major",
          startDate: "2014",
          endDate: "2019",
        },
      ],
      projects: [
        {
          position: "Docker self-hosted Apps",
          url: "https://github.com/BaptisteBdn/docker-selfhosted-apps",
          company: "Complete guide with examples to selfhosting using docker",
          description: "Community-first guide to selfhosting with docker and traefik at its core. Containing security measures, automation with ansible, tested backups and updates as well as a multitude of services.",
          startDate: "jan. 2022",
          endDate: "today",
        },
        {
          position: "Custom linux dotfiles",
          url: "https://github.com/BaptisteBdn/dotfiles",
          company: "Linux custom theming using i3",
          description: "Automated theme change with pywal and rounded corners for a minimalist look, featuring EndeavourOS, i3-gaps, pywal and rounded corners.",
          startDate: "nov. 2021",
          endDate: "nov. 2021",
        },
        {
          position: "Budgeter",
          url: "https://github.com/BaptisteBdn/Budgeter",
          company: "Budget web-app to help families manage their expenses",
          description: "Responsive webapp built with VueJS and NodeJs (Express). Including lots of dashboards. ",
          startDate: "feb. 2021",
          endDate: "jun. 2021",
        },
        {
          position: "BF",
          url: "https://github.com/ProjectBlackFalcon",
          company: "Creation of an AI with a complex behavior",
          description: "Work within a search group looking to develop a artificial life within a mainly human virtual environment. \nThis project involved online video game reverse engineering, machine learning, multi-language development and database management.",
          startDate: "sept. 2017",
          endDate: "jul. 2019",
        },
        {
          position: "vSquare",
          url: "https://github.com/BaptisteBdn/VSquare-API",
          company: "Centralized solution for VM management",
          description: "VSquare is a projet based on VSphere. The goal was to create a better, simpler client while adding useful resources, such as LDAP authentication.",
          startDate: "jan. 2018",
          endDate: "jun. 2018",
        },
      ],
      certification: [
        {
          position: "Japanese - JLPT N3",
          company: "JLPT",
          startDate: "2026",
        },
        {
          position: "AWS Certified Solutions Architect - Associate",
          company: "AWS",
          startDate: "2021",
        },
        {
          position: "Voltaire",
          company: "Certificat Voltaire",
          startDate: "2017",
        },
        {
          position: "TOEIC (960/990)",
          company: "The TOEIC Program",
          startDate: "2016",
        }
      ],
    };
  },
  mounted() {
    const $ = this.jquery;
    this.$nextTick(() => {
      // our custom jQuery code goes here
      $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function () {
        if (
          location.pathname.replace(/^\//, "") ===
            this.pathname.replace(/^\//, "") &&
          location.hostname === this.hostname
        ) {
          var target = $(this.hash);
          target = target.length
            ? target
            : $("[name=" + this.hash.slice(1) + "]");
          if (target.length) {
            $("html, body").animate(
              {
                scrollTop: target.offset().top,
              },
              500,
              "easeInOutExpo"
            );
            return false;
          }
        }
      });

      // Closes responsive menu when a scroll trigger link is clicked
      $(".js-scroll-trigger").click(function () {
        $(".navbar-collapse").collapse("hide");
      });

      // Activate scrollspy to add active class to navbar items on scroll
      $("body").scrollspy({
        target: "#sideNav",
      });
    });
  },
};
</script>

<style>
@import "./assets/styles/resume.css";
</style>
